// extracted by mini-css-extract-plugin
export var table = "_w3-0";